import {useEffect} from 'react';

/**
 * Sends the document's current height to the parent window as it changes.
 * Used when this is rendered within an iframe to adjust its size.
 */
function useSendHeight(enable: boolean) {
  useEffect(() => {
    if (!enable) {
      return;
    }
    let height: number | null = null;
    const sendHeight = () => {
      const calculatedHeight =
        window.document.body.getBoundingClientRect().height;
      if (height !== calculatedHeight) {
        height = calculatedHeight;
        window.parent.postMessage({height: calculatedHeight}, '*');
      }
    };

    const observer = new MutationObserver(() => {
      sendHeight();
    });

    observer.observe(window.document.body, {
      childList: true,
      subtree: true,
    });

    window.addEventListener('resize', sendHeight);
    sendHeight();
    return () => {
      window.document.body.removeEventListener('resize', sendHeight);
      observer.disconnect();
    };
  }, [enable]);
}
export default useSendHeight;
